<!-- 美装材料 - 手机端列表 -->
<template>
  <div class="mobile-list-container">
    <!-- 头部 -->
    <div class="mobile-header">
      <h2>优房美装材料使用详情</h2>
    </div>

    <!-- 顶部图片 -->
    <div class="top-image-container">
      <img
        src="https://www.youfanglianmai.com/ts.jpg"
        alt="优房联卖"
        class="top-image"
        @click="showImagePreview"
        @error="handleTopImageError"
      />
    </div>

    <!-- 搜索框 -->
    <div class="search-box">
      <input
        type="text"
        v-model="search.TITLE"
        placeholder="搜索标题..."
        class="search-input"
        @input="handleSearch"
      />
      <span class="search-icon">🔍</span>
    </div>

    <!-- 列表 -->
    <div class="news-list">
      <!-- 加载中 -->
      <div v-if="loading" class="loading-box">
        <div class="loading-spinner"></div>
        <p>加载中...</p>
      </div>

      <!-- 列表内容 -->
      <div v-else-if="tableData.length > 0" class="list-content">
        <div
          v-for="(item, index) in tableData"
          :key="index"
          class="news-item"
          @click="handleViewDetail(item)"
        >
          <!-- 左侧缩略图 -->
          <div class="item-image">
            <img
              v-if="item.URL"
              :src="item.URL"
              :alt="item.TITLE"
              @error="handleImageError"
            />
            <div v-else class="default-image">
              <span class="image-icon">🖼️</span>
            </div>
          </div>

          <!-- 右侧内容 -->
          <div class="item-content">
            <h3 class="item-title">{{ item.TITLE }}</h3>
          </div>

          <!-- 右箭头 -->
          <div class="item-arrow">›</div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-box">
        <div class="empty-icon">📄</div>
        <p>暂无数据</p>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="load-more-box" v-if="hasMore && !loading">
      <button class="load-more-btn" @click="loadMore">
        加载更多
      </button>
    </div>

    <!-- 底部提示 -->
    <div class="footer-tip" v-if="!hasMore && tableData.length > 0">
      没有更多了
    </div>

    <!-- 图片预览模态框 -->
    <div
      v-if="showPreview"
      class="image-preview-modal"
      @click="hideImagePreview"
    >
      <div class="preview-content" @click.stop>
        <img
          src="https://www.youfanglianmai.com/ts.jpg"
          alt="优房联卖"
          class="preview-image"
        />
        <button class="close-btn" @click="hideImagePreview">×</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/common/axiosHttp.js";
import md5 from "js-md5";

export default {
  name: "NewsMobileList",
  data() {
    return {
      op: "adminNewsGlWap",
      search: {
        TITLE: ""
      },
      tableData: [],
      loading: false,
      pageSet: {
        currentPage: 1,
        pageSize: 1000,
        totalNums: 0
      },
      hasMore: true,
      searchTimer: null,
      apiUrl: "https://www.youfanglianmai.com/ptmainApi", //"http://localhost:8996/ptmainApi" //"https://www.youfanglianmai.com/ptmainApi"
      showPreview: false
    };
  },
  created() {
    this.mainLoad();
  },
  methods: {
    // 手机端专用的post请求（不校验session）
    sendMobilePost(paramData) {
      return new Promise((resolve, reject) => {
        const paramJson = JSON.stringify(paramData);
        const Base64 = require("js-base64").Base64;
        const baseStr = Base64.encode(paramJson);
        const sendParam = {
          paramData: baseStr,
          mac: md5(baseStr + "trialSystem000000000001")
        };
        const paramBase64 = Base64.encode(JSON.stringify(sendParam));

        axios.post(this.apiUrl, paramBase64).then(
          response => {
            const data = response.data;
            // 手机端不校验session，直接返回数据
            resolve(data);
          },
          err => {
            console.error("请求失败", err);
            reject(err);
          }
        );
      });
    },

    // 格式化日期时间
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "";
      let str = dateTimeStr.toString().trim();

      // 如果已经格式化好的
      if (str.includes("-") && str.includes(":")) {
        return str;
      }

      // 处理 yyyyMMddHHmmss 格式（14位）
      if (/^\d{14}$/.test(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        const hour = str.substring(8, 10);
        const minute = str.substring(10, 12);
        const second = str.substring(12, 14);
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      }

      // 处理 yyyyMMdd 格式（8位）
      if (/^\d{8}$/.test(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        return `${year}-${month}-${day}`;
      }

      return str;
    },

    // 搜索防抖
    handleSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.pageSet.currentPage = 1;
        this.tableData = [];
        this.hasMore = true;
        this.mainLoad();
      }, 500);
    },

    // 加载数据
    mainLoad() {
      if (this.loading) return;

      this.loading = true;
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "mainLoad"
        },
        busData: busData
      };

      this.sendMobilePost(paramData)
        .then(data => {
          this.loading = false;

          // 调试：打印返回的数据结构
          console.log("服务端返回的完整数据：", data);
          console.log("data.isSuccess:", data.isSuccess);
          console.log("data.content:", data.content);

          if (!data.isSuccess) {
            alert(data.msg || "加载失败");
            return;
          }

          // 尝试多种可能的数据结构
          let newData = [];
          if (data.content) {
            if (data.content.tableData) {
              newData = data.content.tableData;
            } else if (Array.isArray(data.content)) {
              // 如果 content 本身就是数组
              newData = data.content;
            } else if (data.content.list) {
              newData = data.content.list;
            }
          }

          console.log("解析后的数据：", newData);
          console.log("数据长度：", newData.length);

          // 如果是第一页，直接赋值；否则追加
          if (this.pageSet.currentPage === 1) {
            this.tableData = newData;
          } else {
            this.tableData = this.tableData.concat(newData);
          }

          this.pageSet.totalNums =
            data.content.totalNums || newData.length || 0;

          // 判断是否还有更多数据
          const totalPages = Math.ceil(
            this.pageSet.totalNums / this.pageSet.pageSize
          );
          this.hasMore = this.pageSet.currentPage < totalPages;

          console.log("tableData 更新后：", this.tableData);
        })
        .catch(err => {
          this.loading = false;
          console.error("加载失败", err);
          alert("网络错误，请重试");
        });
    },

    // 加载更多
    loadMore() {
      this.pageSet.currentPage++;
      this.mainLoad();
    },

    // 查看详情
    handleViewDetail(item) {
      this.$router.push({
        path: "/newsMobileDetail",
        query: { id: item.ID }
      });
    },

    // 图片加载失败处理
    handleImageError(e) {
      // 图片加载失败时，隐藏img标签，显示默认图标
      e.target.style.display = "none";
      const parent = e.target.parentElement;
      if (parent) {
        parent.innerHTML =
          '<div class="default-image"><span class="image-icon">🖼️</span></div>';
      }
    },

    // 显示图片预览
    showImagePreview() {
      this.showPreview = true;
      // 禁止背景滚动
      document.body.style.overflow = "hidden";
    },

    // 隐藏图片预览
    hideImagePreview() {
      this.showPreview = false;
      // 恢复背景滚动
      document.body.style.overflow = "";
    },

    // 顶部图片加载失败处理
    handleTopImageError(e) {
      e.target.style.display = "none";
    }
  }
};
</script>

<style scoped>
/* 移动端基础样式 */
.mobile-list-container {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 20px;
}

/* 头部 */
.mobile-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 15px 20px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mobile-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

/* 顶部图片容器 */
.top-image-container {
  padding: 15px;
  background: white;
  margin-bottom: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.top-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: block;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.top-image:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.top-image:active {
  transform: scale(0.98);
}

/* 搜索框 */
.search-box {
  position: relative;
  padding: 15px;
  background: white;
}

.search-input {
  width: 100%;
  height: 40px;
  padding: 0 40px 0 15px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.search-input:focus {
  border-color: #667eea;
}

.search-icon {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #999;
}

/* 列表容器 */
.news-list {
  padding: 0 15px;
  margin-top: 10px;
}

/* 列表项 - 左图右文布局 */
.news-item {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

.news-item:active {
  transform: scale(0.98);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  background: #f9f9f9;
}

/* 左侧图片 */
.item-image {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.default-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
}

.image-icon {
  font-size: 24px;
  opacity: 0.5;
}

/* 右侧内容 */
.item-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding-right: 10px;
}

.item-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  line-height: 1.4;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.item-time {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

/* 右箭头 */
.item-arrow {
  flex-shrink: 0;
  font-size: 20px;
  color: #ccc;
  font-weight: 300;
  margin-left: 8px;
}

/* 加载中 */
.loading-box {
  text-align: center;
  padding: 40px 0;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 10px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-box p {
  color: #999;
  font-size: 14px;
}

/* 空状态 */
.empty-box {
  text-align: center;
  padding: 60px 0;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 15px;
  opacity: 0.3;
}

.empty-box p {
  color: #999;
  font-size: 14px;
}

/* 加载更多 */
.load-more-box {
  text-align: center;
  padding: 20px 0;
}

.load-more-btn {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 10px 30px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
}

.load-more-btn:active {
  background: #f5f5f5;
}

/* 底部提示 */
.footer-tip {
  text-align: center;
  padding: 20px 0;
  color: #999;
  font-size: 12px;
}

/* 图片预览模态框 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.preview-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  animation: zoomIn 0.3s ease;
}

@keyframes zoomIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  color: white;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.8);
  transform: rotate(90deg);
}

.close-btn:active {
  transform: rotate(90deg) scale(0.9);
}

/* 响应式 */
@media (min-width: 768px) {
  .mobile-list-container {
    max-width: 768px;
    margin: 0 auto;
  }

  .top-image-container {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newsGlIndex/NewsMobileList.vue